import { DialogContent } from '@mui/material'
import { Button, Row } from 'components'
import { DraggableDialog } from 'components/DraggableDialog/DraggableDialog'
import React, { useRef } from 'react'
import Draggable from 'react-draggable'
import styled from 'styled-components'
import { SPACING } from 'utils'

interface ViewEmailBodyProps {
    showModal: boolean
    emailBody: any
    toggleModal: () => void
}

export default function ViewEmailBody({ showModal, emailBody, toggleModal }: ViewEmailBodyProps) {

    const draggableReference = useRef<Draggable>(null)

    return (
        <DraggableDialog showModal={showModal} width={'md'} reference={draggableReference} onClose={() => toggleModal}>
            <DialogContent>
                <Container>
                    <ContentBodyEmail>
                        <div dangerouslySetInnerHTML={{ __html: emailBody }} />
                    </ContentBodyEmail>
                </Container>
                <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
                    <Button
                        text="Fechar"
                        marginLeft={SPACING.spacing20}
                        onClick={() => toggleModal()}
                    />
                </Row>
            </DialogContent>
        </DraggableDialog>
    )
}

const Container = styled.div`
    width: 100%;
    border: 1px solid black;
`

const ContentBodyEmail = styled.div`
    padding: 1rem 3rem;
`
